const paymentMethod = [
  { id: 1, name: 'PUE - Pago en Una Exhibición', code: 'PUE' },
  // { id: 2, name: 'PIP - Pago Inicial y Parcialidades', code: 'PIP' },
  { id: 3, name: 'PPD - Pago en Parcialidades o Diferido', code: 'PPD' },
  { id: 4, name: 'Por Definir', code: 'NA' }
]

export default paymentMethod
